import type { FaireProductEntity } from "../../entity_types/product";

export const p_ynat8dud5z: FaireProductEntity = {
  token: "p_ynat8dud5z",
  type: "product",
  name: "Women's Valentine's Day Jersey Loungewear Jogger Set",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/ce2733a447892c5a8d91ec9bd0eae98689e5ffc375f4f23bd538562e26d3dbf2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f608234ffb7f4c62989d6e2f420121c9f1e1a305a2d2a882cc7f595382418b64.png",
    "https://cdn.faire.com/fastly/3f38fa0eadf6942319dab4c6673ded3f24bf1171dd0038ba19c4111440217d7d.png",
    "https://cdn.faire.com/fastly/bd698b5452c31b81295ce238adb1f0df1c8ae92a89e86826537778258aa7a544.png",
    "https://cdn.faire.com/fastly/5448013585f28a7f4f040a4495073a10c2ac9cacd26d2a2a32ef14cada168ccf.png",
    "https://cdn.faire.com/fastly/a981bd356670fc7bc057ed03cf519638ae844ac436e0aeb9b4d8076c5da54197.png",
    "https://cdn.faire.com/fastly/7913ae1961ad2ce4e4bfe6b5cf5a006d072453ec056305522487eeb2f320ae4e.png",
    "https://cdn.faire.com/fastly/f59f634d2fb00bdc8828e2d233b27cf58a3da32e825ad3011416b92451644795.png"
  ],
  priceDollars: 60,
  description: "This dreamy Valentine’s Day loungewear set is crafted from buttery-soft Jersey fabric for a luxurious feel that’s perfect for cozy nights in. The classic crew neck top and matching joggers feature cuffed sleeves, a drawstring waist, and patch pockets—making it an effortless Valentine’s Day gift or self-care favorite.\n\nOprah’s Favorite Thing: 2021\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n• 2-piece lounge set includes long sleeve, crew neck top, and jogger pants with double patch pockets and elastic waist with drawstring for adjustable fit\n• Ultra-soft, luxe comfort combo perfect for home, work, and getaways\n• Dream fabric both inside and out, elevating to a new level of softness\n• A bit of spandex for just the right touch of stretch and bounce\n• Sizing from petite to plus makes the perfect gift for everyone\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬 & 𝐂𝐚𝐫𝐞\n• Dream fabric is easy-care, colorfast, and an ultra-soft blend of lightly brushed 96% polyester, 4% spandex\n• Machine washable",
  tags: [],
  msrpDollars: 130,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:11.203Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
